module.exports = __webpack_public_path__ + "img/planning-ppp-2.2c941bd8.png";